<template>
  <div class="container">
    <div class="tab-header">
      <div :class="{'tab-item': true, active: activeName === 'all'}" @click="handleClick('all')">All</div>
    </div>
    <div>
      <el-table :data="list" @sort-change="sortChange">
        <el-table-column label="Date" sortable prop="date"></el-table-column>
        <el-table-column label="Type" prop="type"></el-table-column>
        <el-table-column label="Bulletin" prop="bulletin"></el-table-column>
      </el-table>
      <el-row type="flex" justify="end" style="margin: 20px 0">
        <el-pagination
          :total="total"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :page-sizes="[50, 100, 200]"
          @current-change="changePage"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getUserLimits } from "@/api/login";

export default {
  data() {
    return {
      activeName: "all",
      list: [],
      total: 0,
      queryData: {
        pageNum: 1,
        pageSize: 50
      }
    };
  },
  methods: {
    sortChange() {},
    handleClick(val) {
      this.activeName = val;
    },
    changePage(e) {
      this.queryData.pageNum = e;
    },
    handleSizeChange(e) {
      this.queryData.pageSize = e;
      this.queryData.pageNum = 1;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.wrapper-container {
  padding: 20px;
}
</style>
